import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'

// 쿠키 읽기 함수
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// 로그인 체크 함수 (쿠키만 확인)
function isLoginChecked() {
  return getCookie('loginCheck') === 'true';
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/complexDetail',
    name: 'complexDetail',
    component: () => import('../views/ComplexDetailView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/noti',
    name: 'noto',
    component: () => import('../views/NotiView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/claim',
    name: 'claim',
    component: () => import('../views/ClaimView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/resident',
    name: 'resident',
    component: () => import('../views/ResidentView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/clientManager',
    name: 'client',

    component: () => import('../views/ClientView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/agencyManager',
    name: 'agency',

    component: () => import('../views/AgencyView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/adTransaction',
    name: 'adTransaction',
    component: () => import('../views/AdTransactionView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  },
  {
    path: '/clientTransaction',
    name: 'clientTransaction',
    component: () => import('../views/ClientTransactionView.vue'),
    props: () => ({ complex: getCookie('complex') }) // 쿠키값을 props로 전달
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 전역 네비게이션 가드
router.beforeEach((to, from, next) => {
  const loginCheck = isLoginChecked();

  if (to.path !== '/login' && !loginCheck) {
    next('/login');
  } else if (to.path === '/login' && loginCheck) {
    next('/'); // 모두 admin이므로 /로 이동
  } else {
    next();
  }
});

router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: to.fullPath,
    });
  }
});

export default router
